module.exports = __webpack_public_path__ + "static/img/iphone2.ec33b50.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt2/iphone2.png
// module id = vOB+
// module chunks = 1